// extracted by mini-css-extract-plugin
export var button = "_ck-0";
export var donut = "_ck-1";
export var donutFill = "_ck-3";
export var donutTrack = "_ck-2";